export const SK = "justfortest";
export const AUTH = "YXV0aA==";
export const UUID = "dXVpZA==";
export const TOKEN = "dG9rZW4=";
// export const API_URL = "http://localhost:8787/api";
export const API_URL = "https://apidojo.net/api";